import type { BannerItem } from '@/types'
import Link from 'next/link'
import { type FC } from 'react'
import ImageOptimize from '../ImageOptimize'

interface Props {
  sliders?: Array<BannerItem>
}

export const RegisterSlider: FC<Props> = ({ sliders }: Props) => {
  return (
    <div className={``}>
      <div className='max-w-screen flex'>
        {sliders &&
          sliders.map((slider: BannerItem, index: number) => (
            <Link href={slider.link || '/'} key={index}>
              <ImageOptimize
                className='w-full object-cover'
                src={slider.image}
                alt={slider.title}
                width={1366}
                quality={100}
                height={717}
              />
            </Link>
          ))}
      </div>
    </div>
  )
}

export default RegisterSlider
